import React from "react"
import { Link } from "gatsby"

const NavPartnerLink = ({ to, title, description, icons }) => (
		<div key={to} className="col-3">
			<Link to={to} className="category-link">
				<p
					className="feature-highlight__title"
					style={{ lineHeight: "1.6" }}
				>
					{title}
				</p>
			</Link>
			<p
				className="feature-highlight__description"
				style={{ lineHeight: "1.6" }}
			>
				{description}
			</p>
			<div className="d-flex mt-3">
				{icons.map(icon => (
					<Link
						key={icon}
						to={`/partners/${title.toLowerCase()}/${icon}`}
						className="integration-link"
					>
						<img
							src={require(`../../../assets/icons/platform/round/${icon}.svg`)}
							style={{ height: "32px", marginRight: "4px" }}
							alt={`${icon} logo`}
						/>
					</Link>
				))}
			</div>
		</div>
)

export default NavPartnerLink